import { useState } from "react";
import Navbar from "../components/Navbar";
import useOnLoadPage from "../hooks/useOnLoadPage";
import PhoneNumberInput from "../components/common/PhoneNumberInput";

export default function TwoStepVerificationPage() {
  const [phone, setPhone] = useState("");
  useOnLoadPage({ tabActive: "home" });

  return (
    <div>
      <Navbar />
      <div className={Classname.outerContainer}>
        <div className={Classname.innerContainer}>
          <div className={Classname.headerText}>
            Configure 2-step verification
          </div>
          <p>
            Make your account more secure by using 2-step verification on your
            mobile phone. Why? Read more.
          </p>
          <div>Steps</div>
          <ol>
            <li>1. Insert your mobile phone number below</li>
            <li>2. We’ll send this number a 6-digit code via SMS</li>
            <li>3. Type in this code when you log in to the Supplier Portal</li>
          </ol>
          <div className={Classname.boldText}>Mobile phone</div>

          <PhoneNumberInput
            value={phone}
            onChange={(value) => setPhone(value)}
          />
          <div className="text-sm text-gray-500">
            Note: Charges from your operator may apply
          </div>
          <button className={Classname.button} type="submit">
            Send Code
          </button>
        </div>
      </div>
    </div>
  );
}

const Classname = {
  outerContainer: "bg-gray-200 p-4 items-center h-screen",
  innerContainer:
    "bg-white mx-auto w-full max-w-[500px] lg:p-10 p-2 flex flex-col gap-4 mt-10",
  headerText: "font-semibold",
  boldText: "font-bold",
  formContainer: "w-full flex gap-5",
  selectInput: "rounded lg:w-40 border border-gray-300 p-2 mt-2",
  textInput: "rounded border border-gray-300 p-2 mt-2",
  button: "bg-primary w-fit self-center text-white px-6 py-2 rounded",
};
